import { slugifyOrgName } from "./slugifyOrgName";
/**
 * @param orgName name of org (or name of current namespace)
 * @param ruleId id from the rule text
 * @returns orgName:ruleId
 * slugifies orgName and lowercases snippet name
 */
export const getSnippetAliasName = (orgName: string, ruleId: string) => {
  return `${slugifyOrgName(orgName)}:${ruleId}`.toLowerCase();
};
